import './font.css'
import './tokens.css'
import './overrides.css'

export const components = Object.freeze({})
export const copy = Object.freeze({})
export const options = Object.freeze({})
export const assets = Object.freeze({})
export const icons = Object.freeze({})
